/* 53DN: free Trailpeak beanie picker + pop-up (November 2026). Markup: snippets/cc-beanie-pick.liquid
   Offers are the Jacket & Overtrousers set OR a jacket + free beanie, so jackets paired with overtrousers
   in the bag don't trigger the beanie pop-up. */
/* Tracking (3 Nov 2026): pop-up events are Shopify customer events with the dn_ prefix, so the
   "53DN - GA4 custom events" pixel forwards them to GA4, the same way as sections/dn-tracking.liquid.
   dn_offer_popup_open    pop-up shown        popup_trigger: jacket_added / bag_button
   dn_offer_popup_choose  a beanie tile picked    beanie_title
   dn_offer_popup_colour  a colour picked         beanie_title, beanie_colour
   dn_offer_popup_add     free beanie added to bag   beanie_title, beanie_colour
   dn_offer_popup_error   adding the beanie failed
   dn_offer_popup_close   closed without adding   close_method: close_button / no_thanks / overlay / escape
   Every event also has offer_name, popup_trigger, seconds_open and from_page. */
window.ccOfferTrack = window.ccOfferTrack || function (name, data, tries) {
  tries = tries || 0;
  var d = Object.assign({ offer_name: 'Trailpeak free beanie', from_page: location.pathname }, data || {});
  var ok = false;
  try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { Shopify.analytics.publish(name, d); ok = true; } } catch (e) {}
  if (!ok && tries < 6) { setTimeout(function () { window.ccOfferTrack(name, data, tries + 1); }, 1000); return; }
  try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
};

if (!customElements.get('cc-beanie-pick')) {
  class CcBeaniePick extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-bp-data]').textContent);
      } catch (e) { return; }
      this.tiles = Array.from(this.querySelectorAll('.cc-bp__tile'));
      if (!this.tiles.length) { this.hidden = true; return; }
      this.sel = Number(this.tiles[0].dataset.index);
      this.colour = null;
      this.tiles.forEach((tile) => {
        tile.addEventListener('click', () => {
          this.sel = Number(tile.dataset.index);
          this.colour = null;
          this.render();
          this.track('dn_offer_popup_choose', { beanie_title: this.product.title });
        });
      });
      this.colourWrap = this.querySelector('[data-bp-colours]');
      this.colourWrap.addEventListener('click', (evt) => {
        const btn = evt.target.closest('.cc-bp__val');
        if (!btn || btn.disabled) return;
        this.colour = btn.dataset.value;
        this.render();
        this.track('dn_offer_popup_colour', { beanie_title: this.product.title, beanie_colour: this.colour || '' });
      });
      this.addBtn = this.querySelector('[data-bp-add]');
      this.addLabel = this.addBtn.textContent;
      this.msg = this.querySelector('[data-bp-msg]');
      this.addBtn.addEventListener('click', () => this.add());
      this.render();
    }

    track(name, data) {
      const popup = this.closest('cc-beanie-popup');
      window.ccOfferTrack(name, Object.assign(popup && popup.trackBase ? popup.trackBase() : {}, data));
    }

    render() {
      this.product = this.data[this.sel];
      const colours = this.product.variants.filter((v) => v.available).map((v) => v.colour);
      if (!colours.includes(this.colour)) this.colour = colours[0];
      this.variant = this.product.variants.find((v) => v.available && v.colour === this.colour) || null;

      this.tiles.forEach((tile) => {
        const on = Number(tile.dataset.index) === this.sel;
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
        const img = tile.querySelector('img');
        if (on && img && this.variant && this.variant.image) img.src = this.variant.image;
      });

      this.colourWrap.innerHTML = '';
      colours.forEach((c) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-bp__val';
        b.dataset.value = c;
        b.textContent = c;
        b.setAttribute('aria-pressed', c === this.colour ? 'true' : 'false');
        this.colourWrap.appendChild(b);
      });

      const was = this.querySelector('[data-bp-was]');
      if (was) was.textContent = this.product.price;
      this.addBtn.setAttribute('aria-disabled', this.variant ? 'false' : 'true');
    }

    async add() {
      if (!this.variant || this.busy) return;
      this.busy = true;
      this.msg.textContent = '';
      this.addBtn.setAttribute('aria-disabled', 'true');
      const drawer = document.querySelector('cart-drawer');
      let sections = 'cart-icon-bubble';
      if (drawer && drawer.closest('.shopify-section')) {
        sections += ',' + drawer.closest('.shopify-section').id.replace('shopify-section-', '');
      }
      const routes = (window.theme && theme.routes) || {};
      try {
        const res = await fetch(routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: this.variant.id, quantity: 1, sections: sections, sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || res.status);
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
        this.addBtn.textContent = 'Added to bag';
        setTimeout(() => { this.addBtn.textContent = this.addLabel; }, 1500);
        this.track('dn_offer_popup_add', { beanie_title: this.product.title, beanie_colour: this.colour || '' });
        this.dispatchEvent(new CustomEvent('cc:beanie:added', { bubbles: true }));
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data, true);
        } else {
          window.location.reload();
        }
      } catch (err) {
        this.msg.textContent = "Couldn't add the beanie. Try again.";
        this.track('dn_offer_popup_error', { beanie_title: this.product ? this.product.title : '', error_message: String(err && err.message || '').slice(0, 100) });
      } finally {
        this.busy = false;
        this.addBtn.setAttribute('aria-disabled', this.variant ? 'false' : 'true');
      }
    }
  }
  customElements.define('cc-beanie-pick', CcBeaniePick);
}

if (!customElements.get('cc-beanie-popup')) {
  class CcBeaniePopup extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {
        const d = JSON.parse(this.querySelector('[data-bpp-data]').textContent);
        this.jacketVariants = d.jacketVariants;
        this.jacketProducts = d.jacketProducts;
        this.setJacketProducts = d.setJacketProducts || [];
        this.trouserProducts = d.trouserProducts || [];
        this.beanieProducts = d.beanieProducts;
      } catch (e) { return; }
      this.dialog = this.querySelector('.cc-bpp__dialog');
      this.querySelectorAll('[data-bpp-close]').forEach((el) => el.addEventListener('click', () => {
        let method = 'overlay';
        if (el.classList.contains('cc-bpp__x')) method = 'close_button';
        else if (el.classList.contains('cc-bpp__skip')) method = 'no_thanks';
        this.close(true, method);
      }));
      this.addEventListener('keydown', (evt) => { if (evt.key === 'Escape') this.close(true, 'escape'); });
      this.addEventListener('cc:beanie:added', () => this.close(false));
      // Stop wheel and touch scrolling on the dark overlay from reaching the page behind.
      const block = (evt) => { if (!this.dialog.contains(evt.target)) evt.preventDefault(); };
      this.addEventListener('wheel', block, { passive: false });
      this.addEventListener('touchmove', block, { passive: false });
      // "Choose your free beanie" button in the bag opens the pop-up.
      document.addEventListener('click', (evt) => {
        const opener = evt.target.closest && evt.target.closest('[data-bpp-open]');
        if (!opener) return;
        evt.preventDefault();
        this.open('bag_button');
      });
      document.addEventListener('on:cart:add', (evt) => this.check(evt.detail && evt.detail.variantId));
      document.addEventListener('on:line-item:change', (evt) => {
        const d = evt.detail || {};
        if (evt.target && evt.target.closest && evt.target.closest('cart-items')) return;
        if (Number(d.newQuantity) > Number(d.oldQuantity)) this.check(d.variantId);
      });
    }

    async check(variantId) {
      if (!variantId || this.isOpen || !this.jacketVariants.includes(Number(variantId))) return;
      const routes = (window.theme && theme.routes) || {};
      let cart;
      try {
        const res = await fetch((routes.cart || '/cart') + '.js');
        cart = await res.json();
      } catch (e) { return; }
      let jackets = 0;
      let setJackets = 0;
      let trousers = 0;
      let beanies = 0;
      cart.items.forEach((i) => {
        if (this.jacketProducts.includes(i.product_id)) {
          jackets += i.quantity;
          if (this.setJacketProducts.includes(i.product_id)) setJackets += i.quantity;
        } else if (this.trouserProducts.includes(i.product_id)) {
          trousers += i.quantity;
        } else if (this.beanieProducts.includes(i.product_id)) {
          beanies += i.quantity;
        }
      });
      // A waterproof jacket paired with overtrousers is a set, so it isn't offered a beanie.
      const sets = Math.min(setJackets, trousers);
      if (jackets - sets > beanies) this.open('jacket_added');
    }

    closeOtherDrawers() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.hasAttribute('open')) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
      }
      const quickAdd = document.querySelector('quick-add-drawer[aria-hidden="false"]');
      if (quickAdd && typeof quickAdd.close === 'function') quickAdd.close();
    }

    lockPage() {
      const b = document.body.style;
      if (b.position === 'fixed' && this.locked) return;
      if (!this.locked) this.scrollPos = window.scrollY || window.pageYOffset || 0;
      this.locked = true;
      document.documentElement.classList.add('cc-bpp-lock');
      b.position = 'fixed';
      b.top = '-' + this.scrollPos + 'px';
      b.left = '0';
      b.right = '0';
      b.width = '100%';
    }

    unlockPage() {
      if (!this.locked) return;
      this.locked = false;
      document.documentElement.classList.remove('cc-bpp-lock');
      const b = document.body.style;
      b.position = '';
      b.top = '';
      b.left = '';
      b.right = '';
      b.width = '';
      window.scrollTo(0, this.scrollPos || 0);
    }

    trackBase() {
      return {
        popup_trigger: this.trigger || '',
        seconds_open: this.openedAt ? String(Math.round((Date.now() - this.openedAt) / 1000)) : ''
      };
    }

    open(trigger) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.trigger = trigger || 'other';
      this.openedAt = Date.now();
      window.ccOfferTrack('dn_offer_popup_open', this.trackBase());
      this.reopenDrawer = !!document.querySelector('cart-drawer');
      this.hidden = false;
      // The theme opens the bag drawer a moment after adding. Keep it shut while the pop-up is up.
      this.closeOtherDrawers();
      this.lockPage();
      let ticks = 0;
      clearInterval(this.watch);
      this.watch = setInterval(() => {
        if (!this.isOpen) { clearInterval(this.watch); return; }
        this.closeOtherDrawers();
        this.lockPage();
        ticks += 1;
        if (ticks > 20) clearInterval(this.watch);
      }, 100);
      setTimeout(() => {
        const first = this.dialog.querySelector('.cc-bp__tile[aria-pressed="true"]') || this.dialog;
        first.focus({ preventScroll: true });
      }, 50);
    }

    close(skipped, method) {
      if (!this.isOpen) return;
      if (skipped) window.ccOfferTrack('dn_offer_popup_close', Object.assign(this.trackBase(), { close_method: method || 'other' }));
      this.isOpen = false;
      clearInterval(this.watch);
      this.hidden = true;
      this.unlockPage();
      if (skipped && this.reopenDrawer) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    }
  }
  customElements.define('cc-beanie-popup', CcBeaniePopup);
}